export const PORTFOLIO_FIELD_ORDER = [
  'name',
  'type',
  'zone',
  'currency_type',
  'price',
  'price_unit',
  'start_date',
  'end_date',
  'description',
  'image_uploaded'
] as const

export const PORTFOLIO_FIELD_LABELS: Record<string, string> = {
  name: 'Nombre',
  type: 'Tipo',
  zone: 'Zona',
  currency_type: 'Moneda',
  price: 'Precio',
  price_unit: 'Unidad',
  start_date: 'Inicio',
  end_date: 'Fin',
  description: 'Descripción',
  image_uploaded: 'Imagen'
}

export const POST_FIELD_ORDER = ['content', 'image_uploaded'] as const

export const POST_FIELD_LABELS: Record<string, string> = {
  content: 'Texto del post',
  image_uploaded: 'Imagen o video (opcional)'
}
